import { render, staticRenderFns } from "./project-listing-kanban-toggle.vue?vue&type=template&id=1f05385a&"
import script from "./project-listing-kanban-toggle.vue?vue&type=script&lang=ts&"
export * from "./project-listing-kanban-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./project-listing-kanban-toggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports